import { createFileRoute } from '@tanstack/react-router'
import ReviewSettings from '@/pages/settings/review'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/settings/review'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <ReviewSettings />
}

